import { FromSchema } from 'json-schema-to-ts';
import PipelineResultSchema from './PipelineResultSchema';

import { jsonSchemaTypeHints } from './canonicalSchemaUtils';

const schema = jsonSchemaTypeHints({
  type: 'object',
  title: 'MergedPipelineResults',
  description:
    'All pipeline results (which stores data about emissions) merged together.',
  properties: {
    ...PipelineResultSchema.properties,
    __pipeline_id: {
      description: 'The ID of the pipeline result the row is sourced from.',
      type: 'string',
      examples: ['plr_2dC4CK6wq9dh3FDvTi7y'],
    },
    __pipeline_name: {
      description: 'The name of the pipeline result the row is sourced from.',
      type: 'string',
      examples: ['Fresh run (usr_2uZ3XddVpzArpEjTPe3p)'],
    },
  },
  required: [
    ...PipelineResultSchema.required,
    '__pipeline_id',
    '__pipeline_name',
  ],
} as const);

export interface IMergedPipelineResults extends FromSchema<typeof schema> {}
export default schema;
